<template>
    <div class="" v-cloak>
        <meta
            v-for="(value, key, index) in myOG" 
            :key="index"
            tag="meta" 
            :property="key"
            :content="value" />
    </div>
</template>
<script>
  export default {
    name: 'OpenGraph',
    data: () => {
      return {
        myOG:{},
        myDefaultOG: {"og:title":"John Diva","og:description":"John Diva Rocks","og:image":"https:\/\/divalovers.com\/wp-content\/uploads\/2019\/03\/jd-slider_home6-2296x787.jpg"},
      }
    },
    watch:{
        currentSlug: function (){
           getOpenGraph();
       }
    },
    mounted () {
      this.myOG = this.myDefaultOG;
      //this.getOpenGraph();
    },
    computed: {
    },
    methods: {
      getOpenGraph (){
        // let parser = document.createElement('a');
        // parser.href = path;

        // parser.protocol; // => "http:"
        // parser.hostname; // => "example.com"
        // parser.port;     // => "3000"
        // parser.pathname; // => "/pathname/"
        // parser.search;   // => "?search=test"
        // parser.hash;     // => "#hash"
        // parser.host;     // => "example.com:3000"
        // console.log("OpenGraph: window.location.pathname: " + window.location.pathname);
        let slug =  window.location.pathname.replace(/\/$/, "");
        // console.log("slug : " + slug);
        if (slug==="/" || slug===""){
            slug = "/home";
        }
        if (slug.includes("/news/")) {
            slug = "/news";
        }
        this.$http.get(
          '/getyoast/v1' + slug )
        .then( (response) => {
          this.myOG = response.data;
        }).catch(function (error) {
          this.myOG = this.myDefaultOG;
        });
      }
    },

  };
</script>
